import React, { useEffect, useRef, useState } from 'react';
import numeral from 'numeral';
import './Collection.css'
import CarouselBanner from '../../components/CarouselBanner/CarouselBanner'
import { detectDeviceType } from '../../Helpers/detectDeviceType'
import { BiSolidLeftArrowCircle } from "react-icons/bi";
import PurchaseButton from '../../Global_Layouts/PurchaseButton/PurchaseButton';
import CustomToast from '../../Layouts/CustomToast/CustomToast';
import PackSelector from '../../Layouts/Layouts_PurchaseForm/PackSelector/PackSelector';
import PureModal from 'react-pure-modal';
import { motion } from 'framer-motion';

const imgs_desktop = [
  "https://media-cldnry.s-nbcnews.com/image/upload/t_fit-760w,f_auto,q_auto:best/newscms/2023_17/1989442/230428-nike-vl-2x1.jpg",
]

const imgs_mobile = [
  "https://media.cnn.com/api/v1/images/stellar/prod/comfy-shoes-nike-new-lead.jpg?c=16x9&q=w_800,c_fill",
]

export default function Collection({
    closeModal, cart_items, add_to_cart, remove_from_cart, history, selected_size, collection_products, selectProductFromCollection,
    readData, quantity, first_name, last_name, phone_number, address1, address2, province, city, contact_email, note,
    UTM_params, discount_code, product_data_for_sell, store_with_upsell, product_data_for_upsell,
    free_shipping, shipping_cost, bulk_unit_discount, min_qty_to_get_bulk_discount, min_qty_to_get_free_shipping,
    units
  }) {

  const [selectedProduct, setSelectedProduct] = useState(null)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const device = detectDeviceType()

  const selectProduct = async (product) => {
    const product_inside_id = product.product_inside_id
    await selectProductFromCollection(product)
    setSelectedProduct(product)
  }

  return (
    <div className='Collection'>
      {/* <CarouselBanner imgSrcs={device==="Mobile"? imgs_mobile : imgs_desktop}/> */}
      {collection_products.length > 0?
        <div>
          <div className='SelectSizeTitle'>Encontramos ofertas</div>
          <div className='SelectSizeSubTitle'>{collection_products.filter(cp=>cp.comodin_title).length} resultados</div>
        </div>
        :
        <div>
          <div className='SelectSizeTitle'>No encontramos ofertas</div>
        </div>
      }

      <div className='CollectionList'>
        {
          collection_products.map(product=>
            product.comodin_title && (
              // <div onClick={()=>selectProduct(product)}>
              <div>
                <ProductCard selectedProduct={selectedProduct} selectProduct={()=>selectProduct(product)} product={product} cart_items={cart_items} add_to_cart={add_to_cart} remove_from_cart={remove_from_cart}/>
              </div>
            )
          )
        }
      </div>

      <OtherSizeBtn closeModal={closeModal} history={history}/>

      {/* <div className='sticky-footer'>
        <ShoppingCartWidget 
          cart_items={cart_items} 
          add_to_cart={add_to_cart} 
          remove_from_cart={remove_from_cart}
          readData={readData}
          quantity={quantity}
          first_name={first_name}
          last_name={last_name}
          phone_number={phone_number}
          address1={address1}
          address2={address2}
          province={province}
          city={city}
          contact_email={contact_email}
          note={note}
          UTM_params={UTM_params}
          discount_code={discount_code}
          product_data_for_sell={product_data_for_sell}
          store_with_upsell={store_with_upsell}
          product_data_for_upsell={product_data_for_upsell}
          units={units}
          free_shipping={free_shipping}
          shipping_cost={shipping_cost}
          bulk_unit_discount={bulk_unit_discount}
          min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount}
          min_qty_to_get_free_shipping={min_qty_to_get_free_shipping}
        />
      </div> */}
    </div>
  )
}

export function ProductCard({ units, bulk_unit_discount, selectedProduct, selectProduct, product, cart_items, add_to_cart, remove_from_cart }) {
  // console.log(product.product_inside_id)
  const [ProductData, setProductData] = useState(product)
  const [showPackSelectorModal, setShowPackSelectorModal] = useState(false)

  const [selectedPackId, setSelectedPackId] = useState("0")
  const [selectedPackData, setSelectedPackData] = useState(ProductData.comodin_packs[0])
  const [selectedVariants, setSelectedVariants] = useState([])

  const [addedToCart, setAddedToCart] = useState(false)

  useEffect(() => {
    // console.log("selectedPackData", selectedPackData)
    initializedSelectedVariantsArrayFunction(selectedPackData)
  }, [])

  useEffect(() => {
    setProductData(product)
    setSelectedPackData(product.comodin_packs[0])
  }, [product])

  useEffect(() => {
    if(showPackSelectorModal===true){
      var modal = document.querySelector('.pure-modal');
      var modalBackdrop = document.querySelector(".pure-modal-backdrop")
      modal.style.height = '65%';
      modalBackdrop.style["justify-content"] = 'start';
      modalBackdrop.style["padding-top"] = '50px';
    }
  }, [showPackSelectorModal])

  useEffect(() => {
    initializedSelectedVariantsArrayFunction(selectedPackData)
  }, [selectedPackData])
  
  const addToCart = () => {
    add_to_cart({
      ProductData,
      selectedPackData,
      selectedVariants
    })
    setShowPackSelectorModal(false)
    setAddedToCart(true)
    setTimeout(() => {
      setAddedToCart(false)
    }, 500);
  }

  // FUNCIONA PERFECTO PERO EN RANDOM------------------------
  const initializedSelectedVariantsArrayFunction = (selectedPackData) => {
    let initializedSelectedVariantsArray = []

    if(ProductData.productWithVariations==="SI"){
      ProductData.productOptions.map((variantData, index) => {
        selectedPackData?.units.map(unit=>{
          let activeIndices = variantData.option_is_active.reduce((indices, isActive, i) => {
            if(isActive) indices.push(i);
            return indices;
          }, []);
          let randomIndex = activeIndices[Math.floor(Math.random() * activeIndices.length)];
          let varData = getSelectedVariants({variant: variantData.values[randomIndex], value: randomIndex?.toString()}, unit, index, true);
          initializedSelectedVariantsArray[unit] = {
            ...initializedSelectedVariantsArray[unit],
            [varData.variant_key]: varData.variant_key_value,
            sku: varData.sku,
            variant_title: varData.variant_title,
            variation_index_calculated: varData.variation_index_calculated,
            variation_index_from_product_data: varData.variation_index_from_product_data,
          }
        })
      })
    } else {
      selectedPackData?.units.map(item=>{
        initializedSelectedVariantsArray.push({
          sku: ProductData.productVariations[0].variation_sku,
          variant_title: ProductData.productVariations[0].variation_title,
          variation_index_calculated: "",
          variation_index_from_product_data: "",
        })
      })
    }
    setSelectedVariants(initializedSelectedVariantsArray)
  }
  // FUNCIONA PERFECTO PERO EN RANDOM------------------------

  // ESPECIAL PARA OUTLET ------------------------
  // const initializedSelectedVariantsArrayFunction = (selectedPackData) => {
  //   // console.log("ProductData.productOptions", ProductData.productOptions)
  //   let initializedSelectedVariantsArray = []
  //   if (ProductData.productWithVariations === "SI") {
  //     ProductData.productOptions.forEach((variantData, index) => {
  //       selectedPackData?.units?.forEach(unit => {
  //         let firstActiveIndex = variantData.option_is_active.findIndex(isActive => isActive);
  //         if (firstActiveIndex !== -1) {
  //           let varData = getSelectedVariants({
  //             variant: variantData.values[firstActiveIndex], 
  //             value: firstActiveIndex.toString()
  //           }, unit, index, true);  
  //           initializedSelectedVariantsArray[unit] = {
  //             ...initializedSelectedVariantsArray[unit],
  //             [varData.variant_key]: varData.variant_key_value,
  //             sku: varData.sku,
  //             variant_title: varData.variant_title,
  //             variation_index_calculated: varData.variation_index_calculated,
  //             variation_index_from_product_data: varData.variation_index_from_product_data,
  //           }
  //         }
  //       })
  //     })
  //   }
  //   setSelectedVariants(initializedSelectedVariantsArray)
  // }
  // ESPECIAL PARA OUTLET ------------------------

  // FUNCIONA PERFECTO PERO EN RANDOM------------------------
  const getSelectedVariants = (e, unit, index, isInitialized, value) => {
    if(ProductData.productWithVariations==="SI"){
      let newSelectedVariantObj = {
        ...selectedVariants[unit],
        variant_key: "variant"+index.toString(),
        ["variant"+index]: isInitialized===true? e.variant : value!==undefined && value!==null && value!==""? value.split("@")[0] : e.target.value.split("@")[0],
        ["option"+index]: index.toString(),
        ["value"+index]: isInitialized===true? e.value : value!==undefined && value!==null && value!==""? value.split("@")[1] : e.target.value.split("@")[1]
      }
      let variation_index = ""
      for (let i = 0; i < ProductData.productOptions.length; i++) {
        let OP = newSelectedVariantObj["option"+i]!==undefined? newSelectedVariantObj["option"+i] : i
        let V = newSelectedVariantObj["value"+i]!==undefined? newSelectedVariantObj["value"+i] : "0"
        let content_to_add = "OP"+OP+"-"+"V"+V
        variation_index = variation_index + (i===0? content_to_add : ("/" + content_to_add))
      }
      let variationData = ProductData.productVariations.filter( variationData => variationData.variation_index === variation_index)[0]
      newSelectedVariantObj.sku = variationData.variation_sku
      newSelectedVariantObj.variant_title = variationData.variation_title
      newSelectedVariantObj.variation_index_calculated = variation_index
      newSelectedVariantObj.variation_index_from_product_data = variationData.variation_index
      newSelectedVariantObj.img_src = variationData.variation_img_src
      if(isInitialized===true){
        return {
          variant_key: newSelectedVariantObj.variant_key,
          variant_key_value: newSelectedVariantObj[newSelectedVariantObj.variant_key],
          sku: newSelectedVariantObj.sku,
          variant_title: newSelectedVariantObj.variant_title,
          variation_index_calculated: newSelectedVariantObj.variation_index_calculated,
          variation_index_from_product_data: newSelectedVariantObj.variation_index_from_product_data,
        }
      } else {
        let newSelectedVariantsArray = [...selectedVariants]
        newSelectedVariantsArray[unit] = newSelectedVariantObj
        setSelectedVariants(newSelectedVariantsArray)
      }
    } else {
      const selectedVariants = []
      selectedPackData?.units.map(item=>{
        selectedVariants.push({
          sku: ProductData.productVariations[0].variation_sku,
          variant_title: ProductData.productVariations[0].variation_title,
          variation_index_calculated: "",
          variation_index_from_product_data: "",
        })
      })
      setSelectedVariants(selectedVariants)
    }
  }
  // FUNCIONA PERFECTO PERO EN RANDOM------------------------

  // ESPECIAL PARA OUTLET ------------------------
  // const getSelectedVariants = (e, unit, index, isInitialized, value) => {
  //   let newSelectedVariantObj = {
  //     ...selectedVariants[unit],
  //     variant_key: "variant" + index,
  //     ["variant" + index]: isInitialized ? e.variant : (value ? value.split("@")[0] : e.target.value.split("@")[0]),
  //     ["option" + index]: index.toString(),
  //     ["value" + index]: isInitialized ? e.value : (value ? value.split("@")[1] : e.target.value.split("@")[1])
  //   };
  
  //   let variation_index = "";
  //   ProductData.productOptions.forEach((option, optIndex) => {
  //     let activeValueIndex = optIndex === index ? (isInitialized ? option.values.indexOf(e.variant) : newSelectedVariantObj["value" + index])
  //                                                : option.option_is_active.findIndex(isActive => isActive);
  
  //     if (activeValueIndex !== -1 && option.option_is_active[activeValueIndex]) {
  //       let OP = optIndex.toString();
  //       let V = activeValueIndex;
  //       let content_to_add = "OP" + OP + "-" + "V" + V;
  //       variation_index += variation_index ? ("/" + content_to_add) : content_to_add;
  //     }
  //   });
  //   let variationData = ProductData.productVariations.find(variation => variation.variation_index === variation_index);
  //   // console.log("variation_index", variation_index);
  //   newSelectedVariantObj.sku = variationData ? variationData.variation_sku : "SKU not found";
  //   newSelectedVariantObj.variant_title = variationData ? variationData.variation_title : "Title not found";
  //   newSelectedVariantObj.variation_index_calculated = variation_index;
  //   newSelectedVariantObj.variation_index_from_product_data = variationData ? variationData.variation_index : "Index not found";
  //   if (isInitialized) {
  //     return {
  //       variant_key: newSelectedVariantObj.variant_key,
  //       variant_key_value: newSelectedVariantObj[newSelectedVariantObj.variant_key],
  //       sku: newSelectedVariantObj.sku,
  //       variant_title: newSelectedVariantObj.variant_title,
  //       variation_index_calculated: newSelectedVariantObj.variation_index_calculated,
  //       variation_index_from_product_data: newSelectedVariantObj.variation_index_from_product_data,
  //     };
  //   } else {
  //     let newSelectedVariantsArray = [...selectedVariants];
  //     newSelectedVariantsArray[unit] = newSelectedVariantObj;
  //     setSelectedVariants(newSelectedVariantsArray)
  //   }
  // };
  // ESPECIAL PARA OUTLET ------------------------

  const getSelectedPackData = (e, newSelectedPackData) => {    
    if(selectedPackData !== newSelectedPackData && newSelectedPackData!==undefined && newSelectedPackData!==null && newSelectedPackData!==""){
      setSelectedPackId(e.target.id)
      setSelectedPackData(newSelectedPackData)
      setSelectedVariants([])
    }
  }

  const imgRef = useRef(null);
  const [finalY, setFinalY] = useState(null)
  const [finalX, setFinalX] = useState(null);

  useEffect(() => {
    if (addedToCart && imgRef.current) {
      const imgRect = imgRef.current.getBoundingClientRect();
      const finalY = window.innerHeight - imgRect.bottom - 80;  // Calcula para que termine a 80px del fondo del viewport
      const finalX = 10 - imgRect.left; // Calcula para que termine a 10px desde el lado izquierdo del viewport
      setFinalY(finalY)
      setFinalX(finalX)
    }
  }, [addedToCart, imgRef]);  // Dependencias para el efecto


  return (
    <div >
      <div className="product-card-collection">
        <div style={{ position: 'relative', height: 'auto', width: '100%' }}>
          {addedToCart && (
            <motion.img
              ref={imgRef}
              onClick={selectProduct}
              src={product?.comodin_main_img_src?.file_src}
              alt={product?.comodin_title}
              className="product-image-collection"
              initial={{ opacity: 1, scale: 1, y: 0, x:0 }}
              animate={{ 
                opacity: 0.5,
                scale: 0.5,
                y: finalY,  // Usa la variable calculada
                x: finalX
              }}
              transition={{ 
                duration: 0.5,
                ease: [0.6, 0.01, -0.05, 0.9],  // Custom bezier curve
                opacity: { duration: 0.3 },  // Faster fade out
                scale: {
                  type: "spring",  // Spring physics for the scale
                  stiffness: 700,
                  damping: 30
                }
              }}
              style={{
                position: "absolute",
                zIndex: 9999,
                width: '100%',
                left: 0,
                top: 0
              }}
            />
          )}
        </div>


        <img onClick={selectProduct} src={product?.comodin_main_img_src?.file_src} alt={product?.comodin_title} className="product-image-collection" />
        <div className="product-info-collection">
          <div onClick={selectProduct}>
            <div className="product-title-collection">{product.comodin_title}</div>
            <div className="product-price-collection">
              {/* {numeral(product.comodin_price - (units*bulk_unit_discount)).format('$ 0,0')} */}
              {numeral(product.comodin_price).format('$ 0,0')}
              <span className="product-comparative-price-collection">{numeral(product.comodin_comparative_price).format('$ 0,0')}</span>
            </div>
          </div>
          <div className='badgets-container-collection'>
            <div className='free-shipping-collection'>ENVIO GRATIS</div>
            <div className='cod-collection'>PAGO CONTRA ENTREGA</div>
            <div onClick={()=>setShowPackSelectorModal(true)} className='atc-collection'>AGREGAR AL CARRITO</div>
          </div>
        </div>

        <PureModal
          header=""
          width='94%'
          isOpen={showPackSelectorModal}
          closeButton="Cerrar"
          closeButtonPosition="header"
          onClose={()=>setShowPackSelectorModal(false)}
          footer={<div onClick={addToCart} className='atc-collection' style={{height:"50px", justifyContent:"center", alignItems:"center", display:"flex"}}>AGREGAR AL CARRITO</div>}
        >
          <div style={{marginTop:"30px", marginBottom:"30px", fontWeight:"bold", fontSize:"25px"}}>Confirma talla, color, etc.</div>
          <PackSelector 
            cart_items={cart_items} 
            add_to_cart={add_to_cart} 
            remove_from_cart={remove_from_cart} 
            selectedVariants={selectedVariants} 
            getSelectedVariants={getSelectedVariants} 
            ProductData={ProductData} 
            getSelectedPackData={getSelectedPackData} 
            selectedPackId={selectedPackId} 
            selectedPackData={selectedPackData}
          />
          {/* <div onClick={addToCart} className='atc-collection' style={{marginTop:"50px",height:"50px", justifyContent:"center", alignItems:"center", display:"flex"}}>AGREGAR AL CARRITO</div> */}
        </PureModal>

      </div>
    </div>
  );
}


export function OtherSizeBtn({ closeModal, history }) {
  return (
    <div className='OtherSizeBtn' onClick={() => {
      closeModal()
      history.push('/');
      window.scrollTo(0, 0);  // Añade esta línea para hacer scroll hacia arriba
    }}>
      <BiSolidLeftArrowCircle style={{ marginRight: "5px", fontSize: "30px" }} />
      REGRESAR
    </div>
  )
}
